import React, { Component } from 'react';
import { Layout, Icon } from 'antd';
import { Link } from 'react-router-dom';
import { prop } from 'ramda';
import cx from 'classnames';

import { LogoName, LogoPromo } from 'components/common/elements/Logo';
import { main, promo, login } from 'constants/routes';
import { GuestAuthorizationRoutes } from '../pages/Routes';
import Authorization from '../pages/landing/Authorization';
import Breakpoint from 'components/layout/Breakpoint.js';
export default class GuestLayout extends Component {

    render() {
        const sidebarPage = prop('page', promo.match(
            this.props.location.pathname.replace(new RegExp('=', 'g'), ''))
        );
   
        return (
            <Layout>
                <div className={cx('promo-layout', { 'has-sider': sidebarPage })}>  
                    <div className="promo">
                        <div className="promo-header">
                            <div className="header-left">
                                { !sidebarPage && <LogoPromo /> }
                            </div>
                            <Breakpoint min="sm">
                                <div className="header-right">
                                    <LogoName />
                                </div>
                            </Breakpoint>
                        </div>
                        <div className="invitation">Вступайте в клуб архитекторов Legrand и получайте эксклюзивные привилегии</div>
                        <ul className="advantage">
                            <li><span>Эксклюзивные скидки и бонусы</span></li>
                            <li><span>Автоматизация возврата бонусов</span></li>
                            <li><span>Дайджест лучших проектов</span></li>
                            <li><span>Удобные инструменты для проектирования</span></li>
                        </ul>
                        <div>
                            <Link to={login.path} className="take-part">
                                участвовать
                            </Link>
                        </div>
                    </div>
                    <div className="promo-footer">
                        <div className="workflow"><div className="step">1</div><div className="step-descr">Зарегистрируйся на сайте и пройди верификацию</div></div>
                        <div className="workflow"><div className="step">2</div><div className="step-descr">Создай проект с помощью удобного инструмента</div></div>
                        <div className="workflow"><div className="step">3</div><div className="step-descr">Получи эксклюзивную скидку на покупку продукции в магазинах Legrand</div></div>
                        <div className="workflow"><div className="step">4</div><div className="step-descr">Получи бонус за покупку, а также возможность попасть в дайджест лучщих проектов</div></div>
                    </div>
                    <Breakpoint max="sm">
                        <div className="logo-footer">
                            <LogoName />
                        </div>
                    </Breakpoint>
                </div>
                <Layout className={cx('promo-sidebar', { collapsed: !sidebarPage })}>
                    <div className="sidebar-header">
                        <LogoPromo />
                        <Link className="sidebar-close" to={main.path}>
                            <Icon type="close" />
                        </Link>
                    </div>
                    
                    <Authorization page={sidebarPage}>
                        <GuestAuthorizationRoutes />
                    </Authorization>
                </Layout>
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/GuestLayout.js